<template>
  <div id="back-button-container">
    <router-link
      v-if="back"
      :to="back"
      class="b-btn"
    >
      <img
        src="@shared/assets/img/general/arrow-left-white.svg"
        alt="back"
        class="back-arrow"
      >
      Back to {{ to }}
    </router-link>
    <div
      v-else
      class="b-btn"
      @click="goBack"
    >
      <img
        src="@shared/assets/img/general/arrow-left-white.svg"
        alt="back"
        class="back-arrow"
      >
      Back to {{ to }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackButton',
  props: {
    to: String,
    back: String,
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">

#back-button-container {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1705px;
  margin-top: 8px;
  margin-bottom: 8px;
  padding-top: 15px;
  .b-btn {
    display: flex;
    align-items: center;
    color: $N30;
    font-size: 0.875rem;
    cursor: pointer;
    .back-arrow {
      margin-right: 8px;
      height: 16px;
    }
  }
}
</style>
